import React from 'react';
import { FiEdit } from 'react-icons/fi';
import styled from 'styled-components';
import { HorizontalContent } from '../HorizontalContent';
import { RhButton, RhButtonMode } from '../RhButton';
import { RhCard } from '../RhCard';
import { RhInput, RhInputMode } from '../RhInput';
import { RhTextArea } from '../RhTextArea';
import { SizedBox } from '../SizedBox';
import { colors, Description, H1, H2 } from '../Styles';

type Props = {
  // Inputs
  /** the current form state */
  form: { title: string; description: string };
  /** if user wants to edit title and desc or not */
  isEditingTitle: boolean;

  // Inputs
  /** called when the user wants to edit title and description */
  userClickedEditTitle: () => void;
  /** called when the user edits the fields */
  userUpdatedForm: (formState: { title: string; description: string }) => void;
};

export const TitleAndDescriptionCard: React.FC<Props> = props => {
  return (
    <RhCard mode="tiled">
      <HorizontalContent
        left={<H2>Title and Description</H2>}
        right={
          props.isEditingTitle ? (
            <RhButton mode={RhButtonMode.text} title="Done" onClick={props.userClickedEditTitle} />
          ) : (
            <RhButton
              mode={RhButtonMode.subtle}
              prefixIcon={FiEdit}
              iconSize={18}
              onClick={props.userClickedEditTitle}
            />
          )
        }
      />
      <SizedBox height={10} />
      {props.isEditingTitle ? (
        <>
          <RhInput
            mode={RhInputMode.subtle}
            placeholder="Title here ..."
            style={{ fontSize: 24, fontWeight: 700 }}
            value={props.form.title}
            onChange={e =>
              props.userUpdatedForm({
                ...props.form,
                title: e.target.value,
              })
            }
          />
          <SizedBox height={10} />
          <RhTextArea
            mode={RhInputMode.subtle}
            placeholder="Description here..."
            rows={4}
            style={{ fontSize: 16, fontWeight: 600 }}
            value={props.form.description}
            onChange={e =>
              props.userUpdatedForm({
                ...props.form,
                description: e.target.value,
              })
            }
          />
        </>
      ) : (
        <>
          <H1 color={props.form.title ? colors.normal : colors.grey}>{props.form.title || 'Title...'}</H1>
          <SizedBox height={16} />
          <DescriptionScrollWrapper>
            <Description color={props.form.description ? colors.normal : colors.grey}>
              {props.form.description || 'Description...'}
            </Description>
          </DescriptionScrollWrapper>
        </>
      )}
    </RhCard>
  );
};

const DescriptionScrollWrapper = styled.div`
  max-height: 200px;
  overflow-y: auto;
`;
